import * as actionTypes from "../actions/actionType";

const initialState = {
  dashboardData: [],
  token: "",
  journeysData: null,
};

export const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_DASHBOARD_DATA:
      return {
        ...state,
        dashboardData: action.payload,
        token: action.payload.token,
      };
    case actionTypes.GET_JOURNEYS_DATA:
      return {
        ...state,
        journeysData: action.payload,
      };
    // case actionTypes.USER_LOGOUT:
    //   return {
    //     ...state,
    //     user: null,
    //   };

    default:
      return state;
  }
};
